<h1 class="widget-title">{{ title() }}</h1>

@if (canAdd()) {
  <xui-mat-autocomplete
    placeholder="Search Medication"
    [alwaysShowAddCard]="true"
    [searchObservable]="searchFn()"
    [addItemCardText]="addItemText()"
    [displayResultsCardTemplate]="displayResultsCardTemplate"
    [disabled]="isProcessing()"
    (addNewItem)="onAddNewItem()">
  </xui-mat-autocomplete>
}

<ng-template #displayResultsCardTemplate let-result="result" let-queryText="queryText">
  <div class="d-flex flex-row justify-content-between align-items-center">
    <span [innerHtml]="result.description + ' ' + (result.dosage || '') + ' ' + (result.diagnosisCode || '') | textHighlight: queryText"></span>
    <button mat-icon-button (click)="onItemSelected(result)" [disabled]="isProcessing()">
      <mat-icon>add</mat-icon>
    </button>
  </div>
  <mat-form-field color="primary" appearance="fill" class="compact w-100" subscriptSizing="dynamic">
    <mat-label>Comments/Notes</mat-label>
    <input matInput type="text" [value]="getResultData(result.id).comment" (input)="setResultComment(result.id, $any($event.target).value)"/>
  </mat-form-field>
</ng-template>

@if (isProcessing()) {
  <xui-loading-spinner></xui-loading-spinner>
}

<xm-medication-list-view
  [items]="items()"
  [readonly]="!canDelete()"
  [usePrimaryText]="usePrimaryText()"
  (itemRemoved)="onRemoveItem($event.item, $event.index)">
</xm-medication-list-view>

<div class="widget-footer">
  <ng-content select="[widget-footer]"></ng-content>
</div>
